import { useState } from "react";
import { toast } from "sonner";
import { LogOut, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/common";
import { PushCard } from "@/components/PushCard";
import { ROLE_LABEL } from "@/lib/format";

export default function Profilo() {
  const { user, logout } = useAuth();
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const change = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      toast.success("Password aggiornata");
      setCur("");
      setNw("");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div data-testid="profilo-page" className="max-w-xl">
      <PageHeader title="Profilo" />
      <div className="card-soft mb-4 p-5">
        <p className="text-xl font-extrabold" data-testid="profilo-name">{user.name}</p>
        <p className="text-sm text-muted-foreground">{user.email}</p>
        <p className="mt-2 inline-block rounded-full bg-accent px-3 py-1 text-xs font-bold" data-testid="profilo-role">{ROLE_LABEL[user.role]}</p>
        {user.must_change_password && <p className="mt-3 rounded-xl bg-amber-50 p-3 text-sm font-semibold text-amber-800">Per sicurezza cambia la password iniziale.</p>}
      </div>
      <PushCard />
      <form onSubmit={change} className="card-soft mb-4 space-y-3 p-5">
        <h3 className="flex items-center gap-2 font-bold"><KeyRound className="h-4 w-4 text-primary" />Cambia password</h3>
        <div className="space-y-1"><Label>Password attuale</Label><Input type="password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="profilo-current-password" /></div>
        <div className="space-y-1"><Label>Nuova password (min. 8 caratteri)</Label><Input type="password" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="profilo-new-password" /></div>
        <Button type="submit" disabled={!cur || nw.length < 8} className="rounded-xl font-bold" data-testid="profilo-change-password-button">Aggiorna</Button>
      </form>
      <Button variant="outline" onClick={logout} className="h-12 w-full rounded-xl text-base font-bold" data-testid="logout-button"><LogOut className="mr-2 h-4 w-4" />Esci</Button>
      <p className="mt-4 text-xs text-muted-foreground">Su smartphone puoi installare DR APP dalla schermata principale: Safari → Condividi → «Aggiungi a Home»; Chrome → menu → «Installa app».</p>
    </div>
  );
}
